var e = { exports: {} };
export {
  e as __module
};
//# sourceMappingURL=index.es131.js.map
